export const routes = {
	index: "/",
	diary: "/app/diary",
	feedback: "/app/feedback",
	resources: "/app/resources",
	guide: "/app/guide",
	packages: "/packages",
	login: "/login"
}